import { element } from 'protractor';
import { LoadingService } from './../../../services/loading.service';
import { SearchService } from 'src/app/services/search.service';
import { AfterContentInit, AfterViewChecked, Component, Input, OnInit } from '@angular/core';
import { faDollarSign, faRoad, faBatteryHalf, faBan, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { Vehicle } from 'src/app/models/Vehicle';
import { LstPolicyReservationCaseModel } from 'src/app/models/VehicleReservationCaseDetailsModel';
import { VehicleReservationPolicyReq } from 'src/app/models/VehicleReservationPolicyReq'
import { CancelationPolicyChargeTypes, DepositPolicyPaymentTypes, ExceededDistancePolicyTypes, FuelChargingPolicyTypes, PolicyType, AgeRestrictionPolicyTypes } from 'src/app/models/enums/BookingEnums';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'policies-icons',
  templateUrl: './policies-icons.component.html',
  styleUrls: ['./policies-icons.component.scss']
})
export class PoliciesIconsComponent implements OnInit, AfterContentInit {
  faDollarSign = faDollarSign;
  faRoad = faRoad;
  faBatteryHalf = faBatteryHalf;
  faCalendarAlt = faCalendarAlt;
  faBan = faBan;
  loaded = false;
  currency;
  @Input() vehicle: any;
  @Input() policyRequestModel: any;
  @Input() policyDefinitionId;
  @Input() agencyID: any;
  lstPolicyReservationCaseModel: LstPolicyReservationCaseModel[];

  exceededDistancePolicy: LstPolicyReservationCaseModel;
  cancelationPolicy: LstPolicyReservationCaseModel;
  depositPolicy: LstPolicyReservationCaseModel;
  fuelChargingPolicy: LstPolicyReservationCaseModel;
  //ageRestrictionPolicy: LstPolicyReservationCaseModel;
  loaderButton: any;
  ageRestrictionPolicy: LstPolicyReservationCaseModel;

  //policy:LstPolicyReservationCaseModel;
  constructor(private searchService: SearchService, private loadingService: LoadingService) {
    this.currency = searchService.getCurrency();
  }
  ngAfterContentInit(): void {

  }

  ngOnInit() {

  }


  loadPolicies(buttonID, popOver?: NgbPopover) {




    if (this.lstPolicyReservationCaseModel == null) {
      this.loaderButton = buttonID;
      let req: VehicleReservationPolicyReq = {
        AgencyId: this.policyRequestModel.agencyID,
        ClassId: this.policyRequestModel.classID,
        MakeId: this.policyRequestModel.makeID,
        ModelId: this.policyRequestModel.modelID,
        Year: this.policyRequestModel.year,
        VehicleId: this.policyRequestModel.vehicleID
      }
      setTimeout(() => {
        this.loadingService.updateLoadingState(true);
      });
      this.searchService.getVehicleReservationPolicy(req).subscribe(res => {
        this.loaderButton = null;

        this.lstPolicyReservationCaseModel = res;
        this.loadPolicyVariable(res);
        this.loaded = true;
        this.loadingService.updateLoadingState(false);
        popOver.open();

        //this.policy=res.filter(o => o.policyDefinitionId==2)[0];
      })
    }
    else {
      popOver.open();
    }

  }

  loadPolicyVariable(lstPolicyReservationCaseModel: LstPolicyReservationCaseModel[]) {
    lstPolicyReservationCaseModel.forEach(element => {
      switch (element.policyDefinitionId) {
        case PolicyType.ExceededDistancePolicy:
          this.exceededDistancePolicy = element;
          break;
        case PolicyType.CancelationPolicy:
          this.cancelationPolicy = element;
          break;
        case PolicyType.DepositPolicy:
          this.depositPolicy = element;
          break;
        case PolicyType.FuelChargingPolicy:
          this.fuelChargingPolicy = element;
          break;
        case PolicyType.AgeRestrictionPolicy:
          this.ageRestrictionPolicy = element;
          break;
        // case PolicyType.AgeRestrictionPolicy:
        //   this.AgeRestrictionPolicy = element;
        //   break;
      }
    });
  }


  //#region Enums
  public get policyType(): typeof PolicyType {
    return PolicyType;
  }
  public get exceededDistancePolicyTypes(): typeof ExceededDistancePolicyTypes {
    return ExceededDistancePolicyTypes;
  }
  public get cancelationPolicyChargeTypes(): typeof CancelationPolicyChargeTypes {
    return CancelationPolicyChargeTypes;
  }
  public get depositPolicyPaymentTypes(): typeof DepositPolicyPaymentTypes {
    return DepositPolicyPaymentTypes;
  }
  public get fuelChargingPolicyTypes(): typeof FuelChargingPolicyTypes {
    return FuelChargingPolicyTypes;
  }
  public get ageRestrictionPolicyTypes(): typeof AgeRestrictionPolicyTypes {
    return AgeRestrictionPolicyTypes;
  }
  // public get AgeRestrictionPolicyTypes(): typeof AgeRestrictionPolicyTypes {
  //    return AgeRestrictionPolicyTypes;
  // }
  //#endregion

}
